// extracted by mini-css-extract-plugin
module.exports = {"RemoveSVG_container":"IconSVG_RemoveSVG_container__yZoD-"};